<template>
    <div>
        <List
            title="Manage Devices"
            @read="load()"
            write="Add Device"
            @write="add()"
        >
            <template v-slot:header>
                <b-badge class="mr-2" variant="dark">
                    {{devices.filter(device => device.connected).length}}/{{
                        devices.length
                    }}
                    connected
                </b-badge>
            </template>
            <DeviceCard
                v-for="device in devices"
                :key="device._id"
                :id="device._id"
            />
            <template v-slot:modal>
                <Input text="Name" v-model="newDevice.name" />
                <Input text="Nickname" v-model="newDevice.nickname" />
                <Input text="User" :value="userName" disabled
            /></template>
        </List>
    </div>
</template>

<script>
    import DeviceCard from './card'

    import List from '@/components/general/list'

    import Input from '@/components/form/input'

    export default {
        props: ['userName'],
        data() {
            return {
                newDevice: {}
            }
        },
        methods: {
            load() {
                return this.$store.dispatch(
                    'admin/devices/loadByUser',
                    this.userName
                )
            },
            add() {
                return this.$store
                    .dispatch('admin/devices/add', {
                        ...this.newDevice,
                        userName: this.userName
                    })
                    .then(() => {
                        this.load()
                        this.newDevice = {}
                        this.$bvToast.toast('Device added.', {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
            }
        },
        computed: {
            devices() {
                return this.$store.getters['admin/devices/getByUser'](this.userName)
            }
        },
        components: {
            DeviceCard,
            Input,
            List
        }
    }
</script>